/**
 * @file Next.jsのパスプレフィックス生成ユーティリティ
 *
 * 環境変数NEXT_PUBLIC_URL_PREFIXを利用して、
 * サブディレクトリ配置時にパスが正しく解決されるようにする。
 * 画像パスやページ遷移先のURL生成に使用される。
 */

/**
 * 指定パスにプレフィックスを付与した完全なURLパスを返す
 * @param path ベースパスからの相対パス
 * @returns プレフィックス付きのパス
 */
const url = (path: string): string => {
  const urlPrefix = process.env.NEXT_PUBLIC_URL_PREFIX || '';
  return urlPrefix + path;
};

export default url;
